import { Navigate, Route, Router } from "@solidjs/router";
import { lazy, type Component } from "solid-js";
import Layout from "./components/Layout";
import { isAuthenticated } from "./lib/auth";

const Login = lazy(() => import("./routes/login"));
const ItemsList = lazy(() => import("./routes/items/index"));
const ItemDetail = lazy(() => import("./routes/items/[id]"));
const MyTickets = lazy(() => import("./routes/me/tickets"));
const AdminItems = lazy(() => import("./routes/admin/items"));
const AdminTickets = lazy(() => import("./routes/admin/tickets"));
const AdminClients = lazy(() => import("./routes/admin/clients"));
const AdminClientDetail = lazy(() => import("./routes/admin/clients/[id]"));
const AdminRules = lazy(() => import("./routes/admin/rules"));
const AdminGroups = lazy(() => import("./routes/admin/groups"));
const AdminGroupDetail = lazy(() => import("./routes/admin/groups/[id]"));
const AdminItemDetail = lazy(() => import("./routes/admin/items/[id]"));
const AdminAI = lazy(() => import("./routes/admin/ai"));

const Protected = (props: { children: any }) =>
  isAuthenticated() ? props.children : <Navigate href="/login" />;

const Home: Component = () =>
  isAuthenticated() ? <Navigate href="/items" /> : <Navigate href="/login" />;

const App: Component = () => (
  <Router root={Layout}>
    <Route path="/" component={Home} />
    <Route path="/login" component={Login} />
    <Route path="/items" component={() => <Protected>{<ItemsList />}</Protected>} />
    <Route path="/items/:id" component={() => <Protected>{<ItemDetail />}</Protected>} />
    <Route path="/me/tickets" component={() => <Protected>{<MyTickets />}</Protected>} />
    <Route path="/admin/items" component={() => <Protected>{<AdminItems />}</Protected>} />
    <Route
      path="/admin/items/:id"
      component={() => <Protected>{<AdminItemDetail />}</Protected>}
    />
    <Route path="/admin/tickets" component={() => <Protected>{<AdminTickets />}</Protected>} />
    <Route path="/admin/clients" component={() => <Protected>{<AdminClients />}</Protected>} />
    <Route
      path="/admin/clients/:id"
      component={() => <Protected>{<AdminClientDetail />}</Protected>}
    />
    <Route path="/admin/rules" component={() => <Protected>{<AdminRules />}</Protected>} />
    <Route path="/admin/groups" component={() => <Protected>{<AdminGroups />}</Protected>} />
    <Route
      path="/admin/groups/:id"
      component={() => <Protected>{<AdminGroupDetail />}</Protected>}
    />
    <Route path="/admin/ai" component={() => <Protected>{<AdminAI />}</Protected>} />
  </Router>
);

export default App;
